<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="12">
            <a-form-item :label="language['portal.unitName']">
              <a-input  v-model="queryParam.portalOrgName"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item :label="language['portal.unitCode']">
              <a-input  v-model="queryParam.portalOrgCode"></a-input>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>
              <!--<a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>-->
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->



    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">{{language['common.insertButton']}}</a-button>
      <!--<a-button type="primary" icon="download" @click="handleExportXls('sys_portal_org')">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      &lt;!&ndash; 高级查询区域 &ndash;&gt;
      <j-super-query :fieldList="superFieldList" ref="superQueryModal" @handleSuperQuery="handleSuperQuery"></j-super-query>-->

      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{language['common.delete']}}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{language['common.batchAction']}} <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{language['common.choosed']}} <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>{{language['common.item']}}
        <a style="margin-left: 24px" @click="onClearSelected">{{language['common.clear']}}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:1200}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">


        <template slot="imgSlot" slot-scope="text, record, index">
          <div class="anty-img-wrap">
            <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
            <img v-else :src="getImgViewCode(text,applicationCode)" @click="imgView(getImgViewCode(text,applicationCode))"alt="" style="font-size: 12px;font-style: italic;cursor: pointer;"/>
          </div>
        </template>





        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">{{language['common.edit']}}</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">{{language['common.more']}} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">{{language['common.detailsButton']}}</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm :title="language['common.deleteConfirmInfo']" @confirm="() => handleDelete(record.id)">
                  <a>{{language['common.delete']}}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
      <a-modal
        class="mi-modal"
        :mask="false"
        :width="1000"
        height="90%"
        :title="language['ad.image']"
        :visible="previewVisible"
        :confirm-loading="false"
        :ok-button-props="{ props: { disabled: true } }"
        @cancel="handleCancel"
        :cancelText="language['common.closeButton']">
        <div>
          <img alt="example"  :src="previewImage" />
        </div>
      </a-modal>
    </div>

    <sys-portal-org-modal ref="modalForm" @ok="modalFormOk"></sys-portal-org-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import SysPortalOrgModal from './modules/SysPortalOrgModal'

  export default {
    name: 'SysPortalOrgList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      SysPortalOrgModal
    },
    data () {
      return {
        description: 'sys_portal_org管理页面',
        queryParam: {},
        url: {
          list: "/sys/portal/sysPortalOrg/list",
          delete: "/sys/portal/sysPortalOrg/delete",
          deleteBatch: "/sys/portal/sysPortalOrg/deleteBatch",
          exportXlsUrl: "/sys/portal/sysPortalOrg/exportXls",
          importExcelUrl: "sys/portal/sysPortalOrg/importExcel",

        },
        dictOptions:{},
        superFieldList:[],
        previewVisible: false,
        previewImage: '',
        applicationCode:'platform'
      }
    },
    created() {
    this.getSuperFieldList();
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      language() {
        return this.$store.getters.language
      },
      columns(){
        if(this.language){
          return [
            {
              title: '#',
              dataIndex: '',
              key:'rowIndex',
              width:60,
              align:"center",
              customRender:function (t,r,index) {
                return parseInt(index)+1;
              }
            },
            {
              width: 100,
              title:this.language['portal.unitCode'],
              align:"center",
              ellipsis:true,
              dataIndex: 'portalOrgCode'
            },
            {
              width: 250,
              title:this.language['portal.unitName'],
              ellipsis:true,
              align:"center",
              dataIndex: 'portalOrgName'
            },
            {
              title:this.language['ad.file'],
              width: 200,
              ellipsis:true,
              align:"center",
              dataIndex: 'imgPath',
              scopedSlots: {customRender: "imgSlot"}
            },
            {
              title:this.language['portal.unitDesc'],
              ellipsis:true,
              align:"center",
              width: 500,
              dataIndex: 'portalOrgDesc'
            },
            {
              title:this.language['portal.unitStatus'],
              align:"center",
              width: 100,
              dataIndex: 'status_dictText'
            },
            {
              width: 100,
              title:this.language['portal.unitSortNo'],
              align:"center",
              dataIndex: 'sortNo'
            },
            {
              title: this.language['common.action'],
              dataIndex: 'action',
              align:"center",
              fixed:"right",
              width:147,
              scopedSlots: { customRender: 'action' }
            }
          ]
        }
      }
    },
    methods: {
      initDictConfig(){
      },
      getSuperFieldList(){
        let fieldList=[];
        fieldList.push({type:'string',value:'portalOrgCode',text:'单位编码'})
        fieldList.push({type:'string',value:'portalOrgName',text:'单位名称'})
        fieldList.push({type:'string',value:'portalOrgDesc',text:'单位简介'})
        fieldList.push({type:'string',value:'status',text:'单位状态'})
        fieldList.push({type:'int',value:'sortNo',text:'顺序'})
        fieldList.push({type:'string',value:'remark',text:'备注'})
        fieldList.push({type:'string',value:'delFlag',text:'删除标示'})
        this.superFieldList = fieldList
      },
      imgView(text){
        this.previewImage = text;
        this.previewVisible = true;
      },
      // 关闭模态框
      handleCancel() {
        this.previewVisible = false;
      }
    }
  }
</script>
<style scoped lang="less">
  @import '~@assets/less/common.less';
  .anty-img-wrap{
    height: 50px;

  }
  .ant-modal-body div {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 600px;
    overflow: hidden;
    object-fit: cover;
  }

</style>